/**
 * Created by vladislav on 5/7/2024
 */

const CoolMathGames = function () {
    GDCom.call(this, connector.COOLMATHGAMES);
};
CoolMathGames.prototype.constructor = CoolMathGames;
CoolMathGames.prototype = Object.create(GDCom.prototype);
